import { useState, useMemo } from "react";
import Button from "@mui/material/Button";
import { useAppSelector } from "../../../hooks";
import TextField from "@mui/material/TextField";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { dbUpdateGroupMatch3 } from "../../../api/api";
import { TeamType } from "../../../types/types";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { TableCellIconStyles } from "../../../styles/theme";
import NotificationService from "../../../components/notification/NotificationService";

interface Props {}

const EditMatch = (props: Props) => {
  const editingMatch = useAppSelector((state) => state.matches.editingMatch);
  const navigate = useNavigate();
  const allTeams = useAppSelector((state) => state.teams.teams);

  const [homeTeam, setHomeTeam] = useState<string>(
    editingMatch?.homeTeam?.id ?? ""
  );
  const [awayTeam, setAwayTeam] = useState<string>(
    editingMatch?.awayTeam?.id ?? ""
  );

  const teams = useMemo(() => {
    return allTeams.filter(
      (team) => team.group?.pulje.id === editingMatch?.pulje.id
    );
  }, [allTeams, editingMatch]);

  const onSwapHandler = () => {
    const prevHomeTeam = homeTeam;
    setHomeTeam(awayTeam);
    setAwayTeam(prevHomeTeam);
  };

  const updateMatch = async () => {
    if (!editingMatch) return;

    dbUpdateGroupMatch3(homeTeam, awayTeam, editingMatch.id)
      .then(() => {
        NotificationService.showToast({
          severity: "success",
          text: "Kampen blev opdateret.",
        });
        navigate(ROUTES.ADMIN_MATCHES);
      })
      .catch(() => {
        NotificationService.showToast({
          severity: "error",
          text: "Der skete en fejl under opdatering af kampen.",
        });
      });
  };

  return (
    <Container maxWidth={"sm"}>
      <Stack spacing={3}>
        <Typography variant="h4">Rediger kamp</Typography>
        <Card>
          <form autoComplete="off" noValidate onSubmit={() => {}}>
            <Card>
              <CardHeader
                subheader="Udfyld følgende oplysninger:"
                title={editingMatch ? "Opdater kamp" : "Ny kamp"}
              />
              <CardContent sx={{ pt: 0 }}>
                <Box sx={{ m: -1.5 }}>
                  <Grid container justifyContent="space-between">
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid xs={4} md={5} padding={1} item>
                        <TextField
                          fullWidth
                          label="Hjemmehold"
                          name="group"
                          onChange={(e) => setHomeTeam(e.target.value)}
                          required
                          select
                          SelectProps={{ native: true }}
                          value={homeTeam}
                        >
                          {teams.map((team: TeamType) => (
                            <option key={team.id} value={team.id}>
                              {team.teamName}
                            </option>
                          ))}
                        </TextField>
                      </Grid>
                      <SwapHorizIcon
                        sx={TableCellIconStyles}
                        onClick={onSwapHandler}
                      />
                      <Grid xs={4} md={5} padding={1} item>
                        <TextField
                          fullWidth
                          label="Udehold"
                          name="group"
                          onChange={(e) => setAwayTeam(e.target.value)}
                          required
                          select
                          SelectProps={{ native: true }}
                          value={awayTeam}
                        >
                          {teams.map((team: TeamType) => (
                            <option key={team.id} value={team.id}>
                              {team.teamName}
                            </option>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
              <Divider />
              <CardActions sx={{ justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate(ROUTES.ADMIN_MATCHES)}
                >
                  Fortryd
                </Button>
                <Button variant="contained" onClick={updateMatch}>
                  Opdater
                </Button>
              </CardActions>
            </Card>
          </form>
        </Card>
      </Stack>
    </Container>
  );
};

export default EditMatch;
